import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listPaySheets } from "../../../services/karkhanaApi";
import { fmtDay, rupees } from "../rates/rateModel";
import { useKT } from "../i18n/kt";
import { kp } from "../karkhanaPaths";

/** The most recent pay sheet: its dates, how many are paid, and the total. */
const LastSheetCard = () => {
  const { t } = useKT();
  const [sheet, setSheet] = useState<any>(undefined);

  useEffect(() => {
    listPaySheets()
      .then((res: any) => setSheet(res?.success ? (res.data || [])[0] || null : null))
      .catch(() => setSheet(null));
  }, []);

  if (sheet === undefined) return null;
  return (
    <Link to={sheet ? kp.paySheet(sheet.id) : kp.paySheets()} className="kpy-card is-link">
      <div className="kpy-card__main">
        <strong>{t("Last pay sheet")}</strong>
        <span>
          {sheet
            ? `${fmtDay(sheet.from)} – ${fmtDay(sheet.to)} · ${t("{{paid}} of {{n}} paid", { paid: sheet.paid, n: sheet.people })} · ${rupees(sheet.netDue, 0)}`
            : t("No pay sheets yet.")}
        </span>
      </div>
      <span aria-hidden="true">›</span>
    </Link>
  );
};

export default LastSheetCard;
